import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
import LANGUAGES, { findLanguage } from '../languages';
import { CaretBottomIcon } from '../../../components/Icons';
import Dropdown from '../../../components/Dropdown';

var SelectLanguage =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SelectLanguage, _React$Component);

  function SelectLanguage() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SelectLanguage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SelectLanguage)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (event) {
      event.preventDefault();
    });

    _defineProperty(_assertThisInitialized(_this), "onStateChange", function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          isOpen = _ref.isOpen;

      return isOpen !== undefined && _this.props.editor.command(isOpen ? 'deactivateToolbar' : 'activateToolbar');
    });

    return _this;
  }

  _createClass(SelectLanguage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          readOnly = _this$props.readOnly,
          className = _this$props.className,
          style = _this$props.style,
          onChange = _this$props.onChange,
          value = _this$props.value;
      return React.createElement("div", {
        onMouseDown: this.onMouseDown,
        className: classNames('flexbox', 'note-editor-select-language-container', className),
        style: style,
        spellCheck: false,
        contentEditable: false
      }, React.createElement(Dropdown, {
        itemToString: function itemToString(item) {
          return item ? findLanguage(item).name : '';
        },
        onSelect: onChange,
        onStateChange: this.onStateChange
      }, function (_ref2) {
        var getInputProps = _ref2.getInputProps,
            getItemProps = _ref2.getItemProps,
            getRootProps = _ref2.getRootProps,
            getButtonProps = _ref2.getButtonProps,
            isOpen = _ref2.isOpen,
            inputValue = _ref2.inputValue,
            highlightedIndex = _ref2.highlightedIndex;
        return React.createElement(Dropdown.Wrapper, Object.assign({
          className: classNames('note-editor-select-language', {
            'is-open': isOpen
          })
        }, getRootProps({
          refKey: 'innerRef'
        })), React.createElement("button", Object.assign({
          style: {
            minWidth: 100,
            transition: 'background-color 0.2s ease-in-out, color 0.2s ease-in-out'
          },
          className: classNames('flexbox', 'flexbox-align-center', 'flexbox-justify-center', 'padding-vertical-small', 'padding-horizontal-normal', 'radius-normal', 'border-none', 'background-shade-45', 'shade-10', 'font-weight-bold', 'font-size-large', 'text-align-left', 'no-outline', {
            'shade-05-on-hover': !readOnly,
            'background-shade-40-on-hover': !readOnly,
            pointer: !readOnly
          })
        }, readOnly ? {} : getButtonProps()), React.createElement("div", {
          className: "flexbox flexbox-space-between width-full flexbox-align-center"
        }, React.createElement("div", {
          className: classNames('flexbox-grow', 'font-weight-medium', {
            'margin-right-small': !readOnly
          })
        }, findLanguage(value).name), !readOnly && React.createElement("div", {
          className: "flexbox-no-grow"
        }, React.createElement(CaretBottomIcon, {
          size: 10,
          style: {
            marginTop: -2
          }
        })))), isOpen && React.createElement(Dropdown.Body, {
          placement: "bottom-right",
          style: {
            marginTop: 5,
            maxHeight: 400,
            zIndex: 10
          }
        }, React.createElement(Dropdown.SearchInput, getInputProps({
          withIcon: false,
          placeholder: 'Find a language...'
        })), React.createElement(Dropdown.Menu, {
          scrolling: true
        }, LANGUAGES.filter(function (language) {
          return language.name.toLowerCase().includes((inputValue || '').toLowerCase());
        }).map(function (language, index) {
          return React.createElement(Dropdown.Item, Object.assign({
            key: language.id,
            selected: highlightedIndex === index,
            className: "padding-vertical-small font-weight-medium",
            style: {
              lineHeight: 'inherit'
            }
          }, getItemProps({
            item: language.id,
            index: index
          })), React.createElement("div", {
            className: classNames('font-size-normal font-weight-medium', {
              'shade-05': highlightedIndex === index,
              'shade-10': highlightedIndex !== index
            })
          }, language.name));
        }))));
      }));
    }
  }]);

  return SelectLanguage;
}(React.Component);

export default SelectLanguage;